// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  AreaChartOutlined,
  BorderOutlined,
  BoxPlotOutlined,
  DeploymentUnitOutlined,
  GatewayOutlined,
  InsertRowLeftOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined,
  SmileOutlined,
  StopOutlined
} from '@ant-design/icons';

import SearchIcon from '@mui/icons-material/Search';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { APP_RIGHTS } from 'config';
// icons
const icons = {
  SearchIcon,
  MenuUnfoldOutlined,
  BoxPlotOutlined,
  StopOutlined,
  BorderOutlined,
  SmileOutlined,
  GatewayOutlined,
  QuestionOutlined,
  DeploymentUnitOutlined,
  ScheduleIcon,
  CategoryOutlinedIcon,
  InsertRowLeftOutlined,
  AreaChartOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other = {
  id: 'other',
   //title: <FormattedMessage id=" " />,
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: <FormattedMessage id="dashboard" />,
      type: 'item',
      url: '/archive/dashboard',
      icon: icons.AreaChartOutlined,
      rights: APP_RIGHTS.DASHBOARD
    },
    {
      id: 'search',
      title: <FormattedMessage id="meta-search" />,
      type: 'item',
      url: '/archive/search',
      icon: icons.SearchIcon
    },
    {
      id: 'category',
      title: <FormattedMessage id="category_search" />,
      type: 'item',
      url: '/archive/category-search',
      icon: icons.CategoryOutlinedIcon
    },
    {
      id: 'history',
      title: <FormattedMessage id="history" />,
      type: 'item',
      url: '/archive/history',
      icon: icons.ScheduleIcon,
      rights: APP_RIGHTS.HISTORY
    }
  ]
};

const settings = {
  id: 'settings',
  type: 'group',
  children: [
    {
      id: 'settings',
      title: <FormattedMessage id="column_selection" />,
      type: 'item',
      url: '/settings/column-settings',
      icon: icons.InsertRowLeftOutlined
    }
  ]
};

export  {other ,settings};
